import { ShippingMethodNameWithIcon } from "@/app/(site)/[locale]/checkout/CheckoutContent/components/ShippingMethods"
import { clsx } from "@/src/utils/clsx"

interface SelectedShippingMethodRowProps {
    methodName: string
    deliveryTime?: string | null
    priceLabel: string
    className?: string
}

export default function SelectedShippingMethodRow({
    methodName,
    deliveryTime,
    priceLabel,
    className
}: SelectedShippingMethodRowProps) {
    const radioId = `selected-shipping-method-${methodName.replace(/\s+/g, "-").toLowerCase()}`

    return (
        <div
            className={clsx(
                "flex w-full rounded-lg border border-col-border-neutral bg-col-bg-calm px-12 pb-12 pt-16",
                className
            )}
        >
            <div className="flex w-full min-w-0 items-start gap-8 opacity-50">
                <div className="flex shrink-0 items-center pt-3">
                    <div className="relative flex items-center">
                        <input
                            id={radioId}
                            type="radio"
                            name={radioId}
                            value={methodName}
                            checked
                            disabled
                            readOnly
                            tabIndex={-1}
                            aria-label={methodName}
                            className="size-16 shrink-0 cursor-not-allowed appearance-none rounded-full border border-black bg-black"
                        />
                        <div
                            aria-hidden
                            className="pointer-events-none absolute left-1/2 top-1/2 size-6 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white"
                        />
                    </div>
                </div>

                <div className="flex min-w-0 flex-1 items-start justify-between gap-8">
                    <div className="flex min-w-0 flex-1 flex-col gap-2">
                        <ShippingMethodNameWithIcon methodName={methodName} />
                        {deliveryTime && (
                            <span className="Trade_Gothic_Text_14_150_0_300">
                                {deliveryTime}
                            </span>
                        )}
                    </div>

                    <span className="shrink-0 Trim_Mono_POC_Text_14_130_-5_400_uppercase">
                        {priceLabel}
                    </span>
                </div>
            </div>
        </div>
    )
}
